import React from 'react';
import styles from './RadioGroup.module.scss';

type RadioButtonProps = {
  id: string;
  name: string;
  value: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
};

const RadioButton: React.FC<RadioButtonProps> = ({ id, name, value, checked, onChange, label }) => (
  <div className={styles.radio_button}>
    <input type="radio" id={id} name={name} value={value} checked={checked} onChange={onChange} />
    <label className={styles.label} htmlFor={id}>{label}</label>
  </div>
);

type RadioGroupProps = {
  label: string;
  name: string;
  options: { value: string; label: string }[];
  selectedValue: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const RadioGroup: React.FC<RadioGroupProps> = ({ label, name, options, selectedValue, onChange }) => (
  <div>
    <label className={styles.head_label}>{label}:</label>
    {options.map(option => (
      <RadioButton
        key={option.value}
        id={option.value}
        name={name}
        value={option.value}
        checked={selectedValue === option.value}
        onChange={onChange}
        label={option.label}
      />
    ))}
  </div>
);
